import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import PrimaryButton from "components/Form/Buttons/PrimaryButton";

import AiccBreadCrumb from "components/common/AiccBreadCrumb";
import CustomModal from "components/Modals/CustomModal";
import CommonFieldConfig from "components/common/CommonFieldConfig";
import CenterLoading from "components/common/CenterLoading";
import FieldConfigConvert from "utils/converter/FieldConfigConvert";
import customFields from "services/apis/customFields";
import rulesApi from "services/apis/rulesApi";
import { KEYSET_GROUP_NAME } from "../../../constants";
import PopUpModel from "./PopUpModel";
import { GroupMaker, ListMaker } from "./FieldConfigUI";
import {
  getFieldsList,
  getLastBySplit,
  getParentPathBySplit,
  getPathPrefix,
  getUUID,
  nameCapitalize,
} from "utils/coreUtils";
import CacheUtils from "utils/CacheUtils";
import RuleBuilderConvert from "utils/converter/RuleBuilderConvert";
import "./SchemaStyle.scss";

const listItems = (finalList, handleClick, dragStart) =>
  finalList?.map((item) => {
    return ListMaker(item, handleClick, dragStart);
  });

function FieldConfigJson() {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [loadingContent, setLoadingContent] = useState(false);
  const [loadingFieldConfig, setLoadingFieldConfig] = useState(false);

  const [mainConfigJson, setMainConfigJson] = useState(null);
  const [dataStreamDetails, setDataStreamDetails] = useState();
  const [mappedFieldJson, setMappedFieldJson] = useState({});
  const [schemaList, setSchemaList] = useState([]);
  const [selectedSchema, setSelectedSchema] = useState();

  const [originalGroupData, setOriginalGroupData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [ruleBuilderFields, setRuleBuilderFields] = useState([]);

  const [groupNameList, setGroupNameList] = useState([]);

  const [showDelete, setShowDelete] = useState(false);
  const [noKeyAlert, setNoKeyAlert] = useState(false);
  const [goToBack, setGoToBack] = useState(false);
  const [changeSchemaTo, setChangeSchemaTo] = useState();
  const [viewPopUp, setViewPopUp] = useState(false);
  const [item, setItem] = useState();

  const [modalData, setModalData] = useState({
    parentHeader: "",
    fieldName: "",
    pathName: "",
    groupName: "",
    fieldType: "",
    type: "",
    indexNumber: "",
    isOptionalField: false,
    aggregateFunctionId: -1,
    selectedChild: undefined,
    fields: [],
    fieldList: [],
    aggFieldList: [],
    groupByList: undefined,
    whereClause: [], // empty object should be assigned
  });
  const [isSavingData, setIsSavingData] = useState(false);
  const [groupModalData, setGroupModalData] = useState({
    prevGroupName: "",
    groupName: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const datastreamList = useSelector((state) => state?.datastream?.list);

  const dragItem = useRef();
  let dropData;

  const dragStart = (e, position) => {
    dragItem.current = position;
  };

  const drop = (result) => {
    if (result.destination?.droppableId.indexOf("group-drop-area") > -1) {
      const groupName = result.destination?.droppableId.split("|")[1];
      dropData = null;
      findItemById(result.draggableId, mainConfigJson);
      if (dropData != null) {
        const groupList = groupData.filter(
          (group) => group.name.toLowerCase() === groupName.toLowerCase()
        );
        if (groupList.length > 0) {
          /* const saveData = {
            ...modalData,
            fieldName: dropData.name,
            pathName: dropData.path,
            groupName: groupName,
            parentHeader: dropData.name,
            fields: dropData.fields,
            indexNumber: "",
            aggregateFunctionId: -1,
            fieldList: [],
            aggFieldList: [],
            groupByList: undefined,
            fieldType: dropData.type,
            queryTree: "",
            sqlWhere: "",
            dropped: true,
            geographicalField: false,
          }; */

          handleClickModal({
            ...dropData,
            groupName: groupName,
            fieldName: dropData.name,
            pathName: dropData.path,
            dropped: true,
          });
          // setModalData(saveData);
          // setShowModal(true);
          // handleSave(saveData);
        }
        setGroupData([...groupData]);
      }
    }
  };

  const findItemById = (fieldId, group) => {
    fieldId = fieldId.replaceAll("group-", "");
    if (group != null) {
      if (group.path === fieldId) {
        dropData = group;
        return;
      }
      if (group.fields != null) {
        return group.fields.forEach((filed) => findItemById(fieldId, filed));
      }
      if (group instanceof Array)
        return group.forEach((grp) => findItemById(fieldId, grp));
    }
  };

  const removeFieldFromAllGroup = (pathName, keyToCheck = "pathName") => {
    return groupData.filter((group) => {
      group.children = group.children.filter((child) => {
        return !(child[keyToCheck] === pathName);
      });
      return group;
    });
  };

  const checkIfFieldInOtherGroup = (mData) => {
    if (groupData.length > 0) {
      return (
        groupData?.filter((group) =>
          group.children?.filter((child) => child.formId === mData.formId)
        ).length > 0
      );
    }
    return false;
  };

  const handleGroupSave = (mData) => {
    let groupLocalData = Array.from(groupData);
    const foundedIndex = groupLocalData.findIndex(
      (group) => group.name === mData.prevGroupName
    );
    if (foundedIndex > -1) {
      groupLocalData[foundedIndex].name = mData.groupName;
      groupLocalData[foundedIndex].children = groupLocalData[
        foundedIndex
      ].children.map((child) => ({
        ...child,
        groupName: mData.groupName,
        isUpdated: true,
      }));
    } else {
      groupLocalData.push({
        name: mData.groupName,
        children: [],
      });
    }
    /* let groupLocalData = groupData;
    groupLocalData.forEach((group) => {
      if (group.name === mData.prevGroupName) {
        group.name = mData.groupName;
      }
    }); */
    setGroupData([...groupLocalData]);
    // document.getElementById("btn-close")[0].click();
    setShowGroupModal(false);
  };

  /**
   * Called on save button click of the popup.
   * @param {*} mData
   * @returns
   */
  const handleSave = (mData) => {
    let groupLocalData = Array.from(groupData);

    if (mData.isPrimarySecondary) {
      const findKeySetGroup = groupLocalData.findIndex((e) => e.order === -1);

      mData = {
        ...mData,
        groupId: -1,
      };

      if (findKeySetGroup === -1) {
        groupLocalData.splice(0, 0, {
          name: KEYSET_GROUP_NAME,
          order: -1,
          children: [mData],
        });
      } else {
        const alreadyExistIndex = groupLocalData[
          findKeySetGroup
        ].children.findIndex(
          (e) => e.isPrimarySecondary === mData.isPrimarySecondary
        );

        if (alreadyExistIndex === -1) {
          groupLocalData[findKeySetGroup].children.push(mData);
        } else {
          groupLocalData[findKeySetGroup].children[alreadyExistIndex] = {
            ...groupLocalData[findKeySetGroup].children[alreadyExistIndex],
            ...mData,
          };
        }
      }

      setGroupData([
        ...groupLocalData /* .filter((e) => e.children.length > 0) */,
      ]);
      return;
    }

    if (checkIfFieldInOtherGroup(mData)) {
      groupLocalData = removeFieldFromAllGroup(mData.formId, "formId");
    }
    const groupList = groupLocalData.filter(
      (group) => group.name.toLowerCase() === mData.groupName.toLowerCase()
    );
    if (groupList.length > 0) {
      groupList[0].children.push(mData);
    } else {
      groupLocalData.push({
        name: mData.groupName,
        children: mData.fieldName.trimStart() ? [mData] : [],
      });
    }
    setGroupData([...groupLocalData]);
    // document.getElementsByClassName("btn-close")[0].click();
    setShowModal(false);
  };

  const handleLevelClick = (selectedOption, idx) => {
    const childConfig = JSON.parse(selectedOption.target.value);
    modalData.fieldList.length = idx;
    modalData.fieldList.push(childConfig);
    setModalData({
      ...modalData,
      pathName: childConfig.path,
    });
  };

  const handleGroupClick = (item) => {
    // window.$("#SimpleGroupJsonPathModal").modal("show");
    setShowGroupModal(true);
    setGroupModalData({ groupName: item.name, prevGroupName: item.name });
  };

  const handleGroupItemClick = (item) => {
    const groupByList = mappedFieldJson[getParentPathBySplit(item.pathName)];
    const parentList = mappedFieldJson[item.parentPathName];
    const selectedChild = mappedFieldJson[item.lastSelectedChild];

    setModalData({
      fieldName: "",
      groupName: undefined,
      // whereClause: [{ ...initialWhereClause, id: new Date().getTime() }],
      geographicalField: false,
      ...item,
      ...parentList,
      selectedChild,
      groupByList,
      fieldList: getFieldsList(
        item.parentPathName,
        item.selectedChild?.path ?? item.lastSelectedChild,
        mappedFieldJson
      ),
      dropped: undefined,
      userGrouping: true,
    });
    // window.$("#SimpleJsonPathModal").modal("show");
    setShowModal(true);
  };

  const deleteFieldFromList = (item, type) => {
    const tempList = Array.from(groupData);
    const mappedObj = tempList.map((e) =>
      e.children.findIndex(
        (child) =>
          child.fieldName === item.fieldName &&
          child.customFieldsId === item.customFieldsId
      )
    );

    const parentIndex = mappedObj.findIndex((e) => e > -1);

    if (parentIndex === -1) return;

    const childIndex = mappedObj[parentIndex];

    if (childIndex === -1) return;

    tempList[parentIndex].children[childIndex].isDeleted =
      type === "undo" ? false : true;

    setGroupData(tempList);
  };

  const handleDeleteClick = async (item, type) => {
    if (type === "undo") {
      deleteFieldFromList(item, type);
      return;
    }

    if (!item.customFieldsId) {
      deleteFieldFromList(item);
      return;
    }

    const deleteCustomField =
      await customFields.deleteCustomFieldsByIdWithCheckingRules({
        customFieldsId: item.customFieldsId,
      });
    setViewPopUp(deleteCustomField.data.isActiveRecordFound);

    if (!deleteCustomField.data.isActiveRecordFound) {
      deleteFieldFromList(item);
    }
    // setViewPopUp(true);
    setItem(item);
  };

  const handleClickModal = (item, type) => {
    let groupByList = mappedFieldJson[getParentPathBySplit(item.path)];

    const groupDataToSave = {
      isOptionalField: false,
      formId: item.formId ?? getUUID(),
      fieldName: getLastBySplit(item.name ?? item?.fieldName ?? ""),
      groupName: item.groupName ? item.groupName : undefined,
      groupId:
        groupNameList.find((group) => group?.groupName === item.groupName)
          ?.groupId ?? 0,
      dropped: item.dropped ? item.dropped : undefined,
      type: item.type,
      pathName: item.path,
      dataStreamConfigApiId: selectedSchema?.dataStreamConfigApiId,

      // for child component selection. To find parent list for child components
      parentPathName: item.path,
      parentHeader: item.name,
      fields: item.fields,
      isParent: type === "parent",
      fieldList: [],
      aggFieldList: [],
      selectedChild: undefined,
      geographicalField: false,
      selectedGroupByPath: undefined,
      groupByList,
      aggregateFunctionId: -1,
      whereClause: [], // empty object should be assigned
      fieldType: item.type,
      queryTree: "",
      sqlWhere: "",
    };

    setModalData(groupDataToSave);
    setShowModal(true);
  };
  const fetchJson = async (schema) => {
    setLoadingContent(true);
    const url = schema.jsonFileName;
    try {
      let fieldConfigJson;
      const cachedResponse = await CacheUtils.getCacheResponseTTL(
        "dataStreamFile",
        url
      );

      if (!cachedResponse) {
        const fieldConfigResponse = await rulesApi.getJSONFile(url);
        fieldConfigJson = fieldConfigResponse.data.jsonOutput;
        CacheUtils.cacheResponseTTL("dataStreamFile", url, fieldConfigJson);
      } else {
        fieldConfigJson = cachedResponse;
      }

      const finalJson = FieldConfigConvert.newConvertFunction(
        fieldConfigJson,
        schema?.jsonFileSchemaName
      );
      setMainConfigJson(finalJson);

      setMappedFieldJson(FieldConfigConvert.parentChildConfigJson(finalJson));
      setLoadingContent(false);
    } catch (error) {
      toast.error("Failed to fetch schema details from the server.");
      setLoadingContent(false);
    }
  };

  const getDataStreamByFieldConfig = async () => {
    setLoadingContent(true);
    try {
      const founded = datastreamList?.find(
        (e) => e.dataStreamConfigId == params?.dataStreamConfigId
      );
      if (founded) {
        setDataStreamDetails(founded);
        setSchemaList(founded?.aiccDataStreamJsons ?? []);

        if (founded?.aiccDataStreamJsons[0]) {
          setSelectedSchema({
            ...founded?.aiccDataStreamJsons[0],
            label: nameCapitalize(
              founded?.aiccDataStreamJsons[0].jsonFileSchemaName
            ),
            value: founded?.aiccDataStreamJsons[0].jsonId,
          });

          fetchJson(founded?.aiccDataStreamJsons[0]);
        } else {
          setLoadingContent(false);
        }
      } else {
        setLoadingContent(false);
      }
    } catch (error) {
      setLoadingContent(false);
    }
  };

  const getGroupNameList = async (dataStreamConfigId, schemaId) => {
    try {
      const response = selectedSchema?.dataStreamConfigApiId
        ? await customFields.getGroupNameByDataStreamConfigIdAndDataStreamConfigApiId(
            {
              dataStreamConfigId,
              dataStreamConfigApiId: selectedSchema?.dataStreamConfigApiId,
            }
          )
        : await customFields.getGroupNameByDataStreamConfigIdAndSchemaId({
            dataStreamConfigId,
            schemaId,
          });

      setGroupNameList(response.data);
    } catch (error) {
      /* empty */
    }
  };

  const getFieldConfigJson = async (dataStreamConfigId, schemaId) => {
    if (!dataStreamConfigId || !schemaId) {
      return;
    }
    setIsSavingData(true);
    setLoadingFieldConfig(true);
    try {
      getGroupNameList(dataStreamConfigId, schemaId);

      const response =
        await customFields.getCustomFieldsByDataStreamConfigIdAndSchemaId({
          dataStreamConfigId,
          schemaId,
        });

      const configData = FieldConfigConvert.fieldConfigResListToForm(
        response.data
      );
      setRuleBuilderFields(
        RuleBuilderConvert.aiccRBFieldConfigToGroupedFields([...response.data])
      );
      setGroupData(configData);
      setOriginalGroupData(JSON.stringify(configData));
    } catch (error) {
      setOriginalGroupData([]);
    }
    setIsSavingData(false);
    setLoadingFieldConfig(false);
  };

  const saveFields = async (refresh = true) => {
    setLoadingContent(true);
    try {
      setIsSavingData(true);
      const fieldList = groupData
        .flatMap((e) => e.children)
        .filter((e) =>
          searchParams.get("save") === "1"
            ? true
            : !e.customFieldsId
              ? !e.isDeleted
              : !e.customFieldsId || e.isUpdated || e.isDeleted
        )
        .map(
          FieldConfigConvert.fieldConfigFormToReq(
            params?.dataStreamConfigId,
            selectedSchema.value,
            {
              isApiSchema: selectedSchema?.dataStreamConfigApiId ? true : false,
            }
          )
        );

      await customFields.saveOrUpdateCustomFieldsList(fieldList);

      if (refresh)
        getFieldConfigJson(params?.dataStreamConfigId, selectedSchema?.value);

      if (goToBack) {
        navigate(getPathPrefix("dashboard"));
      }
      toast.success("Configuration saved!!");
    } catch (error) {
      setIsSavingData(false);
    }
    setLoadingContent(false);
  };

  useEffect(() => {
    getFieldConfigJson(params?.dataStreamConfigId, selectedSchema?.value);
  }, [selectedSchema, params?.dataStreamConfigId]);

  useEffect(() => {
    if (params?.dataStreamConfigId !== undefined) {
      getDataStreamByFieldConfig();
    }
  }, [params?.dataStreamConfigId]);

  const schemaSelectOptions = useMemo(() => {
    const apiSchema = schemaList.map((e) => ({
      ...e,
      label: nameCapitalize(e.jsonFileSchemaName),
      value: e.jsonId,
    }));
    return apiSchema;
  }, [schemaList]);

  const filteredGroupData = useMemo(() => {
    return groupData.map((e) => ({
      ...e,
      // children: e.children.filter((ele) => !ele.isDeleted),
    }));
  }, [groupData]);

  const onlyGroupOptions = useMemo(() => {
    return [
      ...(groupData ?? [])
        .map((e) => ({
          ...e,
          label: e.name,
          value: e.name,
        }))
        .filter((e) => e.order > -1),
      ...[
        ...new Set(
          (filteredGroupData ?? [])
            .filter((e) => !e?.order)
            .flatMap((e) => e?.children)
            .filter((e) => !e?.groupId || e?.groupId === 0)
            .map((e) => e.groupName)
        ),
      ].map((e) => ({
        groupId: undefined,
        label: e,
        value: e,
      })),
    ];
  }, [groupData, filteredGroupData]);

  return (
    <div>
      <PopUpModel
        show={viewPopUp}
        item={item}
        onClose={() => {
          setViewPopUp(false);
        }}
      />
      <CustomModal
        show={showDelete}
        centered
        noHeader
        body={
          <h5
            className="modal-title text-center w-100"
            style={{ color: "#004e5c" }}
          >
            {t("fieldConfiguration.saveConfirmationPopup.message", {
              schemaName: selectedSchema?.label,
            })}
          </h5>
        }
        okTitle={t("CommonKeys.yes")}
        cancelTitle={t("CommonKeys.no")}
        centerFooter
        onOk={async () => {
          // deleteHandler(companyToDelete?.companyId);
          await saveFields(false);
          if (!goToBack) {
            try {
              await fetchJson(changeSchemaTo);
            } catch (error) {
              /* empty */
            }
            setSelectedSchema(changeSchemaTo);
            setGroupData([]);
            setShowDelete(false);
          }
        }}
        onCancel={async () => {
          if (goToBack) {
            navigate(getPathPrefix("dashboard"));
          } else {
            try {
              await fetchJson(changeSchemaTo);
            } catch (error) {
              /* empty */
            }
            setSelectedSchema(changeSchemaTo);
            setGroupData([]);
            setShowDelete(false);
          }
        }}
      />

      <CustomModal
        show={noKeyAlert}
        centered
        title={t("fieldConfiguration.noKeyAssignedAlert.title")}
        body={
          <h5
            className="text-danger fw-bold text-center w-100 fs-6"
            style={{ color: "#004e5c" }}
          >
            {t("fieldConfiguration.noKeyAssignedAlert.message")}
          </h5>
        }
        okTitle={t("CommonKeys.okButtonTitle")}
        centerFooter
        onOk={async () => {
          setNoKeyAlert(false);
        }}
      />

      <CenterLoading asModal isVisible={loadingContent || loadingFieldConfig} />

      <AiccBreadCrumb
        homeLink={getPathPrefix("dashboard")}
        title={dataStreamDetails?.customDataStreamName}
        items={t("fieldConfiguration.breadCrumb.items", {
          returnObjects: true,
        })}
      />
      <div className="col-12 mt-4 mx-auto">
        <div className="card main-card-table">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col-12 col-md-12">
                <div className="card-label">
                  <img
                    src="/assets/images/document.svg"
                    alt=""
                    className="me-2"
                    style={{
                      height: "22px",
                      width: "22px",
                    }}
                  />{" "}
                  {t("fieldConfiguration.breadCrumb.title")} -{" "}
                  {dataStreamDetails?.customDataStreamName}
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                {/* <h6
                          className="main-content-label"
                          style={{
                            color: "#3c4858",
                          }}
                        >
                          {dataStreamDetails?.customDataStreamName}
                        </h6> */}
                <ReactSelect
                  classNamePrefix="select"
                  value={selectedSchema}
                  options={schemaSelectOptions}
                  isOptionSelected={(option) => {
                    return option.value === selectedSchema.value;
                  }}
                  // isDisabled={!location?.state?.data}
                  onChange={async (e) => {
                    if (e.value === selectedSchema) {
                      return;
                    }
                    if (originalGroupData !== JSON.stringify(groupData)) {
                      setShowDelete(true);
                      setChangeSchemaTo(e);
                    } else {
                      try {
                        await fetchJson(e);
                        setSelectedSchema(e);
                      } catch (error) {
                        /* empty */
                      }
                    }
                  }}
                />
              </div>
            </div>

            <div className="form">
              <DragDropContext onDragEnd={drop}>
                <div className="row mt-4">
                  <div className="col-lg-6 col-md-12 col-12">
                    <div className="card field-configurator-box">
                      <div className="card-header">
                        {t("fieldConfiguration.leftSideSection.title")}
                      </div>
                      <div className="card-body overflow-auto">
                        <div className="field-configurator-path">
                          <Droppable droppableId="droppable">
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                              >
                                {mainConfigJson &&
                                  listItems(
                                    mainConfigJson,
                                    handleClickModal,
                                    dragStart
                                  )}
                              </div>
                            )}
                          </Droppable>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-12">
                    <div className="card field-configurator-box">
                      <div className="card-header">
                        {t("fieldConfiguration.rightSideSection.title")}
                      </div>
                      <div className="card-body overflow-auto">
                        <div className="field-configurator-path user-group">
                          {filteredGroupData &&
                            GroupMaker(
                              filteredGroupData,
                              handleGroupClick,
                              handleGroupItemClick,
                              handleDeleteClick
                            )}
                          {/* <Droppable droppableId="droppable">
                                    {(provided) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                      >
                                        {groupData &&
                                          GroupMaker(
                                            groupData,
                                            handleGroupClick,
                                            handleGroupItemClick,
                                            handleDeleteClick
                                          )}
                                      </div>
                                    )}
                                  </Droppable> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </DragDropContext>

              {/* <!-- Simple Json Path Modal --> */}
              <CommonFieldConfig
                modalTitle={t("fieldConfiguration.fieldConfigPopup.title")}
                handleLevelClick={handleLevelClick}
                modalDataState={modalData}
                setModalDataState={setModalData}
                handleSave={handleSave}
                showModal={showModal}
                setShowModal={setShowModal}
                showGroupFields={false}
                onlyGroupOptions={onlyGroupOptions}
                ruleBuilderFields={ruleBuilderFields}
                mappedFieldJson={mappedFieldJson}
              />

              <CommonFieldConfig
                modalTitle={t("fieldConfiguration.fieldConfigPopup.title")}
                // handleLevelClick={handleLevelClick}
                modalDataState={groupModalData}
                setModalDataState={setGroupModalData}
                handleSave={handleGroupSave}
                showGroupFields={true}
                showModal={showGroupModal}
                setShowModal={setShowGroupModal}
              />
            </div>

            <div className="d-flex gap-2 justify-content-end pt-3">
              <PrimaryButton
                title={t("CommonKeys.backButtonTitle")}
                icon="fa-solid fa-arrow-left"
                onClick={() => {
                  if (originalGroupData !== JSON.stringify(groupData)) {
                    setShowDelete(true);
                    setGoToBack(true);
                  } else {
                    navigate(getPathPrefix("dashboard"));
                  }
                }}
                variant="secondary"
              />
              <PrimaryButton
                title={t("CommonKeys.saveButtonTitle")}
                icon="fa-regular fa-floppy-disk"
                disabled={
                  searchParams.get("save") === "1"
                    ? false
                    : originalGroupData === JSON.stringify(groupData) ||
                      isSavingData
                }
                onClick={() => {
                  saveFields();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FieldConfigJson;
